import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useCalendar } from '../Calendar'
import { useIsMobile, FormControlLabel, Switch } from '@paintscout/ui'

const useStyles = makeStyles((theme) => ({
  switch: {
    color: theme.palette.text.secondary,
    paddingRight: theme.spacing(0.5)
  }
}))

export default function ShowWeekendsSwitch() {
  const classes = useStyles()
  const { hideWeekends, setHideWeekends, view } = useCalendar()
  const mobile = useIsMobile({ xs: true })

  const handleSetWeekends = (value: boolean) => {
    localStorage.setItem('calendarHideWeekends', value ? 'false' : 'true')
    setHideWeekends(value)
  }

  if (view === 'day') {
    return null
  }

  return (
    <FormControlLabel
      className={classes.switch}
      label={mobile ? 'Weekends' : 'Show Weekends'}
      labelPlacement="start"
      control={<Switch checked={!hideWeekends} onChange={() => handleSetWeekends(!hideWeekends)} />}
    />
  )
}
